import { ApiLinkEntity, ApiLinkRel } from 'config/constants';
import { Guid, IApiLink } from "@/types";
import CalculationDetailsVersionComment, { IGetCalculationDetailsVersionCommentDto } from './CalculationDetailsVersionComment';

export interface IGetCalculationDetailsVersionCommentsDto {
    entities: IGetCalculationDetailsVersionCommentDto[]
    links: IApiLink[]
}

export default class CalculationDetailsVersionComments {
    items: CalculationDetailsVersionComment[]

    linkCreate?: IApiLink

    constructor(dto: IGetCalculationDetailsVersionCommentsDto) {
        this.items = dto.entities.map(commentDto => new CalculationDetailsVersionComment(commentDto))

        this.linkCreate = dto.links?.find(lnk =>
            lnk.entity === ApiLinkEntity.calculationVersionComment
            && lnk.rel === ApiLinkRel.new
        )
    }

    provideUserEmails(emails: Record<Guid, string>) {
        this.items.forEach(comment => comment.provideUserEmail(emails[comment.userId]))
    }
}
